<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<!-- THIS WHOLE TEMPLATE NEEDS TO BE RE-THOUGHT THROUGH-->
<template>
    <vx-card :collapse-action="true" :title="`Premium Content Properties (${language.name})`">


      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-select
            label="Premium Content Book/Title"
            v-model="selectedCyclopediaId"
            class="mr-4 w-full vs-input-shadow-drop vs-select-no-border">
            <vs-select-item
              v-for="item in cyclopedias"
              :key="item.id"
              :value="item.id"
              :text="`${item.name} (${localizedCyPropsFor(item).length})`"
            />
          </vs-select>
        </div>
      </div>


<!--      <template v-for="cyclopedia in cyclopedias">-->

        <div v-if="selectedCyclopedia" class="vx-row no-gutter">
          <div class="vx-col w-full">
            <ProductCyclopediaPropertiesEditor
              :localized-filtered-properties="localizedCyPropsFor(selectedCyclopedia)"
              :language="language"
              :cyclopedia="selectedCyclopedia"
              v-on:unsavedChangesUpdate="$emit('unsavedChangesUpdate', $event)"
              >
            </ProductCyclopediaPropertiesEditor>
          </div>
        </div>
<!--      </template>-->


    </vx-card>



</template>

<script>
  import types from '@/models';
  import {productHelpers} from '@/models/helpers';
  import ProductCyclopediaPropertiesEditor from './ProductCyclopediaPropertiesEditor'

  export default {
    components: {
      ProductCyclopediaPropertiesEditor,
    },
    data() {
      return {
        types: types,
        selectedCyclopediaId: 0,
        helpers: productHelpers,
      }
    },
    props: {
      product: {
        type: types.Product,
        required: true,
      },
      language: {
        type: types.Language,
        required: true,
      },
      cyclopedias: {
        type: Array,
        required: true,
        default: () => {
          return [new types.Cyclopedia()]
        }
      },
    },
    watch: {
      // product: function (newVal, oldVal) {
      //   if (JSON.stringify(newVal.cyclopedia_product_properties) === JSON.stringify(oldVal.cyclopedia_product_properties)) return;
      //   this.cyclopedias.forEach((cyclopedia) => {
      //     this.propsByCyclopediaId[cyclopedia.id] = this.localizedCyPropsFor(cyclopedia);
      //   });
      // },
      cyclopedias: function (newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        if (this.selectedCyclopedia.id !== 0) return;
        if (newVal.length <= 0) return;
        this.selectedCyclopediaId = newVal[0].id;
      },
      selectedCyclopediaId: function (newVal, oldVal) {
        if (newVal === oldVal) return;
      },
    },
    computed: {
      selectedCyclopedia() {
        try {
          const match = this.cyclopedias.filter((c)=>c.id===this.selectedCyclopediaId)[0];
          return new types.Cyclopedia(match);
        } catch (e) {
          return new types.Cyclopedia();
        }
      }
    },
    methods: {
      localizedCyPropsFor(cyclopedia) {
        let foo = this.product.cyclopedia_product_properties.filter(
          (cyProp) => {
            try {
              return cyProp.cyclopedia.id === cyclopedia.id && cyProp.language_id === this.language.language_id;
            } catch (e) {
              return false;
            }
          }
        );
        // console.log(JSON.stringify(foo));
        return foo;
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
